import { Api } from "../../api/api";

export class NotificaionPolicyApi extends Api {
    public static refresh(relativeElem: HTMLElement) {
        return Api.callApiFn(relativeElem, "s25-ng-notification-policy", "refresh");
    }
}
